/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerifyPasswordResetDto } from '../../models/verify-password-reset-dto';

export interface UserClientControllerVerifyPasswordResetCodeV1$Params {
      body: VerifyPasswordResetDto
}

export function userClientControllerVerifyPasswordResetCodeV1(http: HttpClient, rootUrl: string, params: UserClientControllerVerifyPasswordResetCodeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'resetToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, userClientControllerVerifyPasswordResetCodeV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'resetToken'?: string;
      }>;
    })
  );
}

userClientControllerVerifyPasswordResetCodeV1.PATH = '/api/v1/users/client/find/password/verify';
